<template>
  <v-card class="py-3 px-3 mb-3">
    <div class="d-flex align-center justify-space-between mb-3">
      <h4 class="text-uppercase">
        {{ $vuetify.lang.t('$vuetify.labels.customer') }}
      </h4>
    </div>

    <div class="d-flex align-center mb-4">
      <div>
        <h4 class="text-uppercase">
          {{ order.firstName }}
          {{ order.lastName }}
        </h4>
        <div class="lighten" v-if="order.customerId">
          {{ $vuetify.lang.t('$vuetify.labels.customerRegistered') }}
        </div>
        <div class="lighten" v-else>
          {{ $vuetify.lang.t('$vuetify.labels.customer') }}
        </div>
      </div>
    </div>
    <div>
      <div class="d-flex align-center">
        <v-icon color="primary" small>$vuetify.icons.envelope</v-icon>
        <span class="ml-3">
          {{ order.email }}
        </span>
      </div>
      <div class="d-flex align-center">
        <v-icon color="primary" small>$vuetify.icons.phone</v-icon>
        <span class="ml-3">
          {{ order.dialCode }}
          {{ order.phone }}
        </span>
      </div>
      <div class="d-flex align-center mt-2">
        <v-icon color="primary" small>$vuetify.icons.event</v-icon>
        <span class="ml-3">
          {{ order.birthAt ? formatDate(order.birthAt) : '-' }}
        </span>
      </div>
      <div class="d-flex align-center">
        <v-icon color="primary" small>$vuetify.icons.creditCard</v-icon>
        <span v-if="order.bankAccountNumber || order.bankCode" class="ml-3">
          {{ order.bankAccountNumber }}/{{ order.bankCode }}
        </span>
        <span v-if="order.bankAccountIban || order.bankSwiftCode" class="ml-3">
          IBAN: {{ order.bankAccountIban || '-' }}
          <br>
          SWIFT: {{ order.bankSwiftCode || '-' }}
        </span>
        <span v-if="!order.bankAccountNumber && !order.bankCode && !order.bankAccountIban && !order.bankSwiftCode" class="ml-3">
          -
        </span>
      </div>
    </div>
  </v-card>
</template>

<script>
import { formatDate } from '@/common/helpers/date';

export default {
  props: {
    order: {
      type: Object,
      default: null,
    },
  },
  methods: {
    formatDate,
  },
};
</script>

<style lang="scss" scoped></style>
